@defer {
  <app-side-nav></app-side-nav>
  @if (isMobile) {
    <app-header></app-header>
  }
}


<div class="relative h-max">
  @if (playBubbleAnime) {
    <app-particles-background class="absolute h-full w-full"></app-particles-background>
  }
  <div class="md:pl-[18.75rem] md:pb-0 relative transition-all duration-500 ease">
    <router-outlet></router-outlet>
    @defer (on idle) {
      @if (
        (isActiveGame && !isMobile && !isSportBook && !isNotFoundPage) ||
        (!isSportBook && !isActiveGame && !isNotFoundPage)
      ) {
        <app-footer></app-footer>
      }
    }
  </div>
</div>
@defer (on idle) {
  @if(isAuth && !isSportBook && !isSideBarOpen) {
    <a
      [href]="'https://wa.me/18254509124'" 
      target="_blank"
      [class]="(isMobile ? 'bottom-[4rem] right-0 ' : 'bottom-6 right-6 ') + 'fixed cursor-pointer group p-4 rounded-full z-[101]'"
      id="whatsUpSupport">
      <img class="group-hover:scale-110" ngSrc="whatsappCorner" width="67" height="57" alt="support" id="whatsUpLiveSupport" />
    </a>
  }
  @if (!isMobile) {
    <!-- live chat on desktop -->
    @if(!isSportBook) {
      <div
        (click)="openLiveChat()"
        [class]="(isAuth ? 'bottom-[6.5rem] ' : 'bottom-6 ') + 'fixed cursor-pointer group right-6 p-4 rounded-full z-[101]'"
        id="liveSupport">
        <img class="group-hover:scale-110" ngSrc="supportCorner" width="67" height="57" alt="support" id="liveSupport" />
      </div>
    }

    @if (showBackTop) {
      <!-- backtotop on desktop -->
      <div
        [@btnTrigger]
        (click)="navigateTop()"
        (scroll)="onBackScroll($event)"
        class="btn fixed z-[2] top-1/2 right-0 cursor-pointer h-10 font-bold text-[#0C4A6E] dark:text-mainText text-sm rounded-t-md bg-lineLight hover:bg-mainBgLight dark:bg-mainHover/75 px-4 pb-3 pt-3 opacity-50 hover:opacity-100 hover:text-white flex items-center space-x-2 transform -translate-y-full -rotate-90 origin-bottom-right box-shadow gap-[0.625rem]"
        id="backToTop">
        <span>
          {{ 'buttons.to_top_button' | transloco }}
        </span>
        <img class="rotate-90 filter-svg" width="10" height="10" ngSrc="leftArrow" alt="leftArrow" />
      </div>
    }
  }
  <app-global-notification></app-global-notification>
}
